import classNames from 'classnames'
import { Link as LinkReact } from 'react-router-dom'
import style from './Link.module.scss'

const Link = ({ className, darkBg, label, text, onClick, styles, to, type, ...props }) => {

  return (
    <span className={classNames(style.link, className, darkBg && style['dark-bg'], type && style[type])}>
      <LinkReact
        onClick={event => {
          if (onClick) {
            event.preventDefault()
            onClick()
          }
        }}
        to={to}
        styles={styles}
        aria-label={typeof label === 'string' ? label : text}
        {...props}
        ref={(node) => {
          if (node) {
            if (styles?.color){
              node.style.setProperty("color", styles?.color, "important")
            } else if (styles?.color === null){
              node.style.removeProperty("color")
            }
          }
        }}
      >
        {label}
      </LinkReact>
    </span>
  )
}

export default Link
